// extracted by mini-css-extract-plugin
export default {"list":"style-module--list--ggFCm"};